import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { map, Observable, of } from 'rxjs';
import { IHoliday } from '../model/holiday';
import { HolidayService } from '../services/holiday.service';

@Injectable({
  providedIn: 'root'
})
export class HolidayResolver  {
  constructor(
    private holidayService : HolidayService
  ){}

  resolve(
    route: ActivatedRouteSnapshot, 
    state: RouterStateSnapshot
    ): Observable<IHoliday[]> {
    return this.holidayService.searchHolidays({pageNumber: 0, pageSize: 999999})
    .pipe(
      map(response => response.data)
    )
  }
}
